export default __webpack_public_path__ + "static/media/bigquery.7a9920ec.png";